import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle'
import { PeopleAccountsTab } from '../components/PeopleAccountsTab'

export function PlatformAdminDashboardPage() {
  useDocumentTitle('Platform Dashboard')

  return (
    <Box data-testid="platform-admin-dashboard-page">
      <Box sx={{ mb: 3 }}>
        <Typography
          component="h1"
          sx={{ fontWeight: 700, fontSize: 24, lineHeight: '32px', color: '#0f172a' }}
        >
          Dashboard
        </Typography>
        <Typography sx={{ mt: 0.5, fontSize: 14, lineHeight: '20px', color: '#64748b' }}>
          Platform-wide health across people, revenue, and token usage.
        </Typography>
      </Box>
      <PeopleAccountsTab />
    </Box>
  )
}
